<template>
  <div class="signing">
    <div class="content">
      <div class="title">合同列表</div>
      <div class="list"> 
        <div class="item" v-for="item in list" :key="item.id">
          <div class="name">合同名称：{{item.contract_name}}</div>
          <div class="time">签约时间：{{item.createtime}}</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { get, post, put, del } from '../utils/http'
export default {
    name: 'Signing',
    data() {
        return {
          list:[]
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
      getList(){
        post('index/getContractList').then(res => {
            if(res.code == 1){
              console.log(res.data.data)
              this.list = res.data.data
            }
        })
      }
    }
}
</script>

<style scoped>
  .signing{
    width: 100%;
  }
  .content{
    width: 1200px;
    min-height: 100vh;
    margin: 0 auto;
  }
  .title{
    font-size: 30px;
    font-weight: bold;
  }
  .list{
    margin-top: 20px;
  }
  .item{
    width: 100%;
    height: 100px;
    border: 1px solid #ccc;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item:hover{
    box-shadow: 5px 5px 5px #ccc;
  }
  .name{
    margin-left: 20px;
  }
  .time{
    margin-right: 20px;
  }
</style>